(function () {
  function q(s, c) { return (c || document).querySelector(s); }
  function qA(s, c) { return Array.from((c || document).querySelectorAll(s)); }

  document.addEventListener("DOMContentLoaded", function () {

    const grid = q('#hc-grid');
    if (!grid) return;

    const cards = qA('.hc-card', grid);
    const search = q('#hc-search');
    const clearBtn = q('#hc-clear');
    const categoryChecks = qA('.hc-filter-checkbox');
    const emptyEl = q('#hc-empty');

    function norm(s) {
      return (s || "").toString().trim().toLowerCase();
    }

    function getFilters() {
      return {
        q: norm(search.value),
        cats: categoryChecks.filter(c => c.checked).map(c => norm(c.value))
      };
    }

    function matches(card, filters) {
      const title = norm(card.dataset.title);
      const genes = norm(card.dataset.genes);
      const category = norm(card.dataset.category);

      // search
      if (filters.q) {
        const q = filters.q;
        if (
          title.indexOf(q) === -1 &&
          genes.indexOf(q) === -1 &&
          category.indexOf(q) === -1
        ) return false;
      }

      // category filter
      if (filters.cats.length && !filters.cats.includes(category)) {
        return false;
      }

      return true;
    }

    function render() {
      const f = getFilters();
      let count = 0;

      cards.forEach(card => {
        if (matches(card, f)) {
          card.style.display = "";
          count++;
        } else {
          card.style.display = "none";
        }
      });

      emptyEl.style.display = count ? "none" : "";
    }

    // debounce
    function debounce(fn, delay) {
      let t;
      return function () {
        clearTimeout(t);
        t = setTimeout(fn, delay);
      };
    }

    search.addEventListener("input", debounce(render, 150));
    clearBtn.addEventListener("click", () => {
      search.value = "";
      render();
    });

    categoryChecks.forEach(cb => cb.addEventListener("change", render));

    render();
  });
})();